export default "__VITE_ASSET__B8K0FYLG__"